export default __webpack_public_path__ + "static/marcinz-3ef2ae9c3e361cc00d06140496dc7c38.webp";